import React, { useCallback, useState } from "react";
import { Body1, H6 } from "../../../../components";
import UsersPagePanel from "../users-page-panel";
import UsersPageMobile from "../users-page-mobile";
import UsersPageDesktop from "../users-page-desktop";
import { Container, useTheme } from "@mui/material";
import { usersPageSetModal } from "../reducers/users-page-actions";
import UsersPageModal from "../users-page-modal";
import { useDispatch } from "react-redux";

const STR = {
  title: "Manutenção de usuários",
  subtitle: "Aqui você pode gerenciar os usuários do sistema.",
  titleFab: "Adicionar novo usuário",
  labelFab: "Adicionar",
};

function UsersTab() {
  const isMobile = useTheme()?.isMobile;
  const [filter, setFilter] = useState("");
  const dispatch = useDispatch();
  //
  const onAdd = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.ADD,
      })
    );
  }, [dispatch]);
  return (
    <Container maxWidth="md" disableGutters>
      <H6>{STR.title}</H6>
      <Body1 align="center">{STR.subtitle}</Body1>
      <UsersPagePanel
        filter={filter}
        setFilter={setFilter}
        onAdd={onAdd}
        title={STR.titleFab}
        label={STR.labelFab}
        color="success"
      />
      {isMobile ? (
        <UsersPageMobile filter={filter} />
      ) : (
        <UsersPageDesktop filter={filter} />
      )}
    </Container>
  );
}

export default UsersTab;
